// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AtomFileLink } from "./AtomFileLink";
import {
  AtomFileLinkFromJSON,
  AtomFileLinkFromJSONTyped,
  AtomFileLinkToJSON,
  AtomFileLinkToJSONTyped,
} from "./AtomFileLink";
import type { OGCWebServiceRead } from "./OGCWebServiceRead";
import {
  OGCWebServiceReadFromJSON,
  OGCWebServiceReadFromJSONTyped,
  OGCWebServiceReadToJSON,
  OGCWebServiceReadToJSONTyped,
} from "./OGCWebServiceRead";
import type { AtomServiceFiles } from "./AtomServiceFiles";
import {
  AtomServiceFilesFromJSON,
  AtomServiceFilesFromJSONTyped,
  AtomServiceFilesToJSON,
  AtomServiceFilesToJSONTyped,
} from "./AtomServiceFiles";
import type { OGCWebServiceLayerRead } from "./OGCWebServiceLayerRead";
import {
  OGCWebServiceLayerReadFromJSON,
  OGCWebServiceLayerReadFromJSONTyped,
  OGCWebServiceLayerReadToJSON,
  OGCWebServiceLayerReadToJSONTyped,
} from "./OGCWebServiceLayerRead";

/**
 *
 * @export
 * @interface ResponseDatasetDataLinksInner
 */
export interface ResponseDatasetDataLinksInner {
  /**
   *
   */
  protocol: ResponseDatasetDataLinksInnerProtocolEnum;
  /**
   *
   */
  url: string;
  /**
   *
   */
  layers: Array<OGCWebServiceLayerRead>;
  /**
   *
   */
  title: string;
  /**
   *
   */
  files: Array<AtomFileLink>;
}

/**
 * @export
 */
export const ResponseDatasetDataLinksInnerProtocolEnum = {
  InspireAtom: "INSPIRE Atom",
} as const;
export type ResponseDatasetDataLinksInnerProtocolEnum =
  (typeof ResponseDatasetDataLinksInnerProtocolEnum)[keyof typeof ResponseDatasetDataLinksInnerProtocolEnum];

/**
 * Check if a given object implements the ResponseDatasetDataLinksInner interface.
 */
export function instanceOfResponseDatasetDataLinksInner(
  value: object
): value is ResponseDatasetDataLinksInner {
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (value["protocol"] !== "INSPIRE Atom") return false;

  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("files" in value) || value["files"] === undefined) return false;
  return true;
}

export function ResponseDatasetDataLinksInnerFromJSON(json: any): ResponseDatasetDataLinksInner {
  return ResponseDatasetDataLinksInnerFromJSONTyped(json, false);
}

export function ResponseDatasetDataLinksInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseDatasetDataLinksInner {
  if (json == null) {
    return json;
  }
  return {
    protocol: json["protocol"],
    url: json["url"],
    layers: (json["layers"] as Array<any>).map(OGCWebServiceLayerReadFromJSON),
    title: json["title"],
    files: (json["files"] as Array<any>).map(AtomFileLinkFromJSON),
  };
}

export function ResponseDatasetDataLinksInnerToJSON(json: any): ResponseDatasetDataLinksInner {
  return ResponseDatasetDataLinksInnerToJSONTyped(json, false);
}

export function ResponseDatasetDataLinksInnerToJSONTyped(
  value?: ResponseDatasetDataLinksInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    protocol: value["protocol"],
    url: value["url"],
    layers: (value["layers"] as Array<any>).map(OGCWebServiceLayerReadToJSON),
    title: value["title"],
    files: (value["files"] as Array<any>).map(AtomFileLinkToJSON),
  };
}
